// Mock for react-native-config on web.
// Exposes all env vars used by native code so webpack builds don't crash.
// Values are read from process.env which is populated by dotenv-webpack from .env.web.
export default {
  API_BASE_URL: process.env.API_BASE_URL || 'https://technician-bff-api-dev-afgkdygre5c7end5.z03.azurefd.net/technicianappbff-dev/',
  TTAUTH_BASE_URL: process.env.TTAUTH_BASE_URL || '',
  PRODUCT_BUNDLE_IDENTIFIER: process.env.PRODUCT_BUNDLE_IDENTIFIER || '',
  // Auth provider toggle: 'entra' = Microsoft Entra CIAM, 'ttauth' = TTAuth/GCIP
  AUTH_PROVIDER: process.env.AUTH_PROVIDER || 'entra',
  // Base URL of the deployed SWA (e.g. https://transit-dev.fastertech.ai).
  // Empty string on local dev — relative /videos path is used instead.
  APP_BASE_URL: process.env.APP_BASE_URL || '',
};